import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns as AdapterDateFnsV2 } from '@mui/x-date-pickers/AdapterDateFnsV2';
import { createBrowserHistory } from 'history';
import { StrictMode, useEffect, useMemo, useState } from 'react';
import { CookiesProvider } from 'react-cookie';
import { QueryClient, QueryClientProvider } from 'react-query';
import {
  createBrowserRouter,
  unstable_HistoryRouter as HistoryRouter,
  RouterProvider,
} from 'react-router';

import { DashboardRefreshProvider, useThemeOptions } from '@bai/features';
import { AngularProvider } from '@bai/features/angular-integration';
import {
  AuthProvider,
  CookieStore,
  refreshCookieStore,
} from '@bai/features/user';
import { addValueToGlobals, basePath } from '@bai/utils';
import { ThemeProvider } from '@bai/utils/theme';
import { Environment } from '@bai/utils/types';

import AppHeader from './AppHeader';
import AppRoutes, { AppRouter, getRouteConfig } from './AppRoutes';

// Eagerly load react-datepicker CSS in the main bundle so it is never
// removed by style-loader's reference counting when lazy chunks unmount.
// Must come BEFORE global.css so that datepicker.css (imported by global.css)
// can override react-datepicker's base header/selection styles.
import 'react-datepicker/dist/react-datepicker.css';
// Same reason: dashboard.css (via global.css) overrides these base styles.
import 'react-dropdown-tree-select/dist/styles.css';

import './global.css';

const history = createBrowserHistory();
{
  /* This is the correct way to route in React 18 but causes issues communicating with Angular will need to figure this out before moving to React 19
const appRouter = createBrowserRouter(AppRouter());
*/
}
const queryClient = new QueryClient();
const NODE_ENV = process.env.NODE_ENV;

// Register synchronously at module load time so AngularJS can call it
// during its own bootstrap, before React has mounted and run useEffect.
addValueToGlobals('refreshCookieStore', refreshCookieStore);

export function App() {
  useEffect(() => {
    addValueToGlobals('environment', NODE_ENV as Environment);
    if (process.env.REACT_APP_API_BASE_URL) {
      addValueToGlobals('apiBaseUrl', process.env.REACT_APP_API_BASE_URL);
    }

    if (window._) {
      window._.noConflict();
    }
  }, []);

  const [
    isStudentDashContentRefreshNeeded,
    setIsStudentDashContentRefreshNeeded,
  ] = useState(true);
  const dashboardRefreshProvider = useMemo(
    () => ({
      isStudentDashContentRefreshNeeded,
      setIsStudentDashContentRefreshNeeded,
    }),
    [isStudentDashContentRefreshNeeded],
  );

  return (
    <QueryClientProvider client={queryClient}>
      {}
      {/* @ts-ignore */}
      <HistoryRouter basename={basePath} history={history}>
        <LocalizationProvider dateAdapter={AdapterDateFnsV2}>
          <CookiesProvider cookies={CookieStore}>
            <AngularProvider routeConfig={getRouteConfig()} history={history}>
              <AuthProvider>
                <ThemeProvider useThemeOptions={useThemeOptions}>
                  <AppHeader />
                  <DashboardRefreshProvider value={dashboardRefreshProvider}>
                    <AppRoutes />
                  </DashboardRefreshProvider>
                </ThemeProvider>
              </AuthProvider>
            </AngularProvider>
          </CookiesProvider>
        </LocalizationProvider>
      </HistoryRouter>
    </QueryClientProvider>
  );
}

export default App;
